import { useEffect, useRef } from 'react';

import type { JettonStatus } from '@/entities/jetton';

import { MultiplierEngine } from '../../model/multiplierEngine';

/**
 * React adapter over MultiplierEngine. Keeps a single stable engine instance,
 * feeds it the current round phase, and disposes it on unmount. All math,
 * timing and pub/sub live in the engine — this hook is pure lifecycle glue.
 */
export function useMultiplier(
  status: JettonStatus,
  startTimeMs: number | null,
  crashMultiplier: number | null,
): MultiplierEngine {
  const engineRef = useRef<MultiplierEngine | null>(null);
  engineRef.current ??= new MultiplierEngine();
  const engine = engineRef.current;

  useEffect(() => {
    engine.start({ status, startTimeMs, crashMultiplier });
    return () => engine.stop();
  }, [engine, status, startTimeMs, crashMultiplier]);

  useEffect(() => () => engine.dispose(), [engine]);

  return engine;
}
